// @owners { team: patient-health }
import { LoadingEmptyState, XlPadding } from '@alto/design-system';
import { Experimentation } from '@alto/experimentation';
import { MedList } from '@alto/features';
import React from 'react';
import { getRouteState } from '~shared/selectors/getRouteState';
import { useSelectorShared } from '~shared/store';
import { useAddToCartInterstitialSheets } from '~web/features/checkout/hooks/useAddToCartInterstitialSheets';
import { MyMeds } from '~web/features/my-meds/components/MyMeds';

export const MedListWrapper = () => {
  const routeState = useSelectorShared(getRouteState);
  const origin: string = routeState?.origin || '';
  const { value: showNewMedList, isLoading } = Experimentation.useFeatureFlag('new_med_details_and_med_list');

  if (isLoading) {
    return (
      <XlPadding>
        <LoadingEmptyState />
      </XlPadding>
    );
  }

  if (showNewMedList) {
    return (
      <MedList
        origin={origin}
        useAddToCartInterstitialSheets={useAddToCartInterstitialSheets}
      />
    );
  }
  return <MyMeds params={{ rxNumber: null }} />;
};
